import {_request, _requestForm} from "./api";

export const add = (data, club_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `club-staff/${club_guid}`, method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (competitions_license_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `club-staff/${competitions_license_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (documents_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `club-staff/${documents_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listStaff = (club_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `club-staff/staff/${club_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listUnusedStaff = (data, club_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `club-staff/staff-unused/${club_guid}`, method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};